import { Routes } from '@angular/router';
import { LoginComponent } from './pages/entry/login/login.component';
import { ResetPasswordComponent } from './pages/entry/reset-password/reset-password.component';
import { MainComponent } from './pages/main/main.component';
import { ForgetPasswordComponent } from './pages/entry/forget-password/forget-password.component';
import {
  ALTERNATIVE_REGISTRATION_PATH,
  FORGET_PASSWORD_PATH,
  LOGIN_PATH,
  REGISTRATION_PATH,
  RESET_PASSWORD_PATH,
} from './core/constants';
import { RegistrationComponent } from './pages/entry/registration/registration.component';
import { redirectQrCodeGuard } from './core/guards/redirect-qr-code-guard';

export const routes: Routes = [
  {
    path: LOGIN_PATH,
    component: LoginComponent,
  },
  {
    path: FORGET_PASSWORD_PATH,
    component: ForgetPasswordComponent,
  },
  {
    path: RESET_PASSWORD_PATH,
    component: ResetPasswordComponent,
  },
  {
    path: REGISTRATION_PATH,
    component: RegistrationComponent,
    canActivate: [redirectQrCodeGuard],
    data: {
      page: 'registration',
      action: 'access',
    },
  },
  {
    path: ALTERNATIVE_REGISTRATION_PATH,
    component: RegistrationComponent,
    canActivate: [redirectQrCodeGuard],
    data: {
      page: 'registration',
      action: 'access',
    },
  },
  {
    path: '',
    component: MainComponent,
    loadChildren: () => import('./pages/main/main.routes').then((m) => m.routes),
  },
];
